export const GET_AGENCY_REWARD_DETAILS = 'dashboardStats/getAgencyRewardDetails';
export const GET_AGENCY_REWARD_DETAILS_START =
  'dashboardStats/getAgencyRewardDetailsStart';
export const GET_AGENCY_REWARD_DETAILS_COMPLETE =
  'dashboardStats/getAgencyRewardDetailsCompleted';
export const GET_AGENCY_REWARD_DETAILS_ERROR =
  'dashboardStats/getAgencyRewardDetailsError';

export const UPDATE_AGENCY_REWARD_DETAILS = 'dashboardStats/updateAgencyRewardDetails';
export const UPDATE_AGENCY_REWARD_DETAILS_START =
  'dashboardStats/updateAgencyRewardDetailsStart';
export const UPDATE_AGENCY_REWARD_DETAILS_COMPLETE =
  'dashboardStats/updateAgencyRewardDetailsCompleted';
export const UPDATE_AGENCY_REWARD_DETAILS_ERROR =
  'dashboardStats/updateAgencyRewardDetailsError';

export const GET_ESTIMATED_MONTHLY_COST = 'dashboardStats/getEstimatedMonthlyCost';
export const GET_ESTIMATED_MONTHLY_COST_START =
  'dashboardStats/getEstimatedMonthlyCostStart';
export const GET_ESTIMATED_MONTHLY_COST_COMPLETE =
  'dashboardStats/getEstimatedMonthlyCostCompleted';
export const GET_ESTIMATED_MONTHLY_COST_ERROR =
  'dashboardStats/getEstimatedMonthlyCostError';

export const getAgencyRewardDetails = (payload = {}) => ({
  type: GET_AGENCY_REWARD_DETAILS,
  payload,
});

export const updateAgencyRewardDetails = (payload = {}) => ({
  type: UPDATE_AGENCY_REWARD_DETAILS,
  payload,
});

export const getEstimatedMonthlyCost = (payload = {}) => ({
  type: GET_ESTIMATED_MONTHLY_COST,
  payload,
});
